import { FC, ReactNode } from 'react'
import { InputTextType } from '../../../common/InputType'

type Props = {
    first: InputTextType
    second: ReactNode
}

const TowInputTextWithSecondNode: FC<Props> = (props) => {
    const { first, second } = props

    return (
        <div className="switcher">
            <div>
                <label htmlFor={first.id} className="d-block">
                    {first.icon && <first.icon className="me-1" />}
                    {first.label && `${first.label}:`}
                    {first.required && (
                        <span className="text-light bg-danger badge ms-1">必須</span>
                    )}
                </label>
                <input
                    type={first.type}
                    id={first.id}
                    placeholder={first.placeholder}
                    autoComplete={first.autoComplete}
                    style={{ width: '100%' }}
                    value={first.state}
                    readOnly={first.readonly}
                    maxLength={first.maxLength}
                    onChange={(e) => first.setState(e.target.value)}
                />
            </div>

            <div>{second}</div>

            <div></div>
        </div>
    )
}

export default TowInputTextWithSecondNode
